import { SpinnerTheme } from '../types';
import { colors } from '../constants/colors';

export const spinner: SpinnerTheme = {
  customSpinner: {
    negativeColor: colors.jlMoneyGreenNeon,
    color: colors.jlMoneyGreenDark,
    fillWidth: '2px',
    speed: 0.6,
  },
  spinnerTheme: 'unbranded',
};
